import Form from "@/components/common/form/Form";
import CheckboxInput from "@/components/common/form/inputs/CheckboxInput";
import DateInput from "@/components/common/form/inputs/date/DateInput";
import FormActions from "@/components/common/form/partials/FormActions";
import { api } from "@/config/axios-context";
import useAppContext from "@/utilities/hooks/useAppContext";
import { useState } from "react";

type BookingCancellationFormProps = {
    bookingId: number | string,
    name: string,
    onSuccess?: () => void | Promise<void>
    onReset?: () => void | Promise<void>
}

type FormData = {
    cancelledDate?: Date,
    isNoShowCancellation: boolean
}

const BookingCancellationForm = (props: BookingCancellationFormProps) => {
    const context = useAppContext();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState<FormData>({
        cancelledDate: new Date(),
        isNoShowCancellation: false
    });

    async function onSubmit() {
        try {
            setIsSubmitting(true);
            const response = await api.patch('booking/MarkAsCancelled', {
                id: Number(props.bookingId),
                cancelledDate: formData.cancelledDate,
                isNoShowCancellation: formData.isNoShowCancellation
            });

            if (!response.success) {
                throw response.data;
            }

            context.notify('success', 'request.save.success');
            if (props.onSuccess) {
                const result = props.onSuccess();
                if (result instanceof Promise) {
                    await result;
                }
            }
        } catch (error: any) {
            context.notify('error', 'request.save.error', Array.isArray(error) ? error[0].message : error.message);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Form name={`${props.name}-form`} onSubmit={onSubmit} onReset={props.onReset}>
            <DateInput
                label="fields.cancelledDate.name"
                name="cancelledDate"
                required
                value={formData.cancelledDate}
                onChange={(v) => setFormData({ ...formData, cancelledDate: v })}
            />
            <CheckboxInput
                label="fields.isNoShowCancellation.name"
                name="isNoShowCancellation"
                value={formData.isNoShowCancellation}
                onChange={(v) => setFormData({ ...formData, isNoShowCancellation: v || false })}
            />

            <FormActions
                disableInputs={isSubmitting}
            />
        </Form>
    );
};

export default BookingCancellationForm;